import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { Section } from '../../editor-container/editor-model';
import { DynamicSectionRendererDirective } from './dynamic-section-renderer.directive';
import { SectionRendererComponent } from '@urbannex/storethemes';
import { PreviewService } from '../preview.service';
import { IframeCommunicationService } from '../../services/iframe-communication.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kw-render-preview-sections',
  templateUrl: './render-preview-sections.component.html',
  styleUrls: ['./render-preview-sections.component.scss'],
})
export class RenderPreviewSectionsComponent implements OnInit, OnChanges, AfterViewInit,OnDestroy {
  sections:Section[]
  hasTemplate = true;
  sections$:Subscription;
  updateSelectedPage$:Subscription;
  pageEditState$:Subscription;

  private destroy$:Subject<void> = new Subject<void>()
 

  constructor(
    private cdr: ChangeDetectorRef,
    private el:ElementRef,
    private previewService:PreviewService,
    private communicator: IframeCommunicationService) { }
  
  

  ngOnInit(): void {
    this.sections$ = this.previewService.getSections().pipe(takeUntil(this.destroy$)).subscribe((_sections:Section[]) => {
      console.log(_sections);
      this.sections = _sections;
      this.cdr.detectChanges();
    })
    this.updateSelectedPage$ = this.communicator.receiveFromParent("selectedPage").pipe(takeUntil(this.destroy$))
    .subscribe((info:any) => {
      if(info.data != undefined){
        //console.log(this.el.nativeElement);
        let sectionElements = this.previewService.getSectionElements(this.el.nativeElement);
        this.communicator.send({id:'sections',data:{options:sectionElements}})
      }
    })
    this.pageEditState$ = this.communicator.receiveFromParent("updateSelectedPage").pipe(takeUntil(this.destroy$))
    .subscribe((info:any) => {
      console.log(info)
      let sectionElements = this.previewService.getSectionElements(this.el.nativeElement);
      console.log(sectionElements);
      this.communicator.send({id:'sections',data:{options:sectionElements}})
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["sections"]){
      console.log(this.sections);
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    //this.loadComponent()
    
    this.cdr.detectChanges();
    //console.log(this.el)
    let previewSectionHost = this.el.nativeElement;
    const sectionElements = this.previewService.getSectionElements(previewSectionHost);
    this.communicator.send({id:'sections',data:{options:sectionElements}})
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
